// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var EmailsController = function ($scope, Email, PUtill, gettext, $routeParams, DatepickerUtils) {
    $scope.search = '';
    $scope.status = '';

    $scope.dateRange = { dateFrom: null, dateTo: null };

    $scope.statusName = PUtill.getText('Status');

    $scope.updateFilter = function (func) {
        $scope.emails = $scope.paginator(function (options, callback) {
            return Email.query(options, function () {
                callback();
                if (func)
                    func();
                func = null;
            });
        }, getSearchParams(), 20);
    };

    $scope.setStatus = function (status, defaultLabelName) {
        $scope.statusName = PUtill.getText(defaultLabelName || status);
        $scope.status = status;
        $scope.updateFilter();
    };

    $scope.clearSearchInput = function () {
        $scope.search = '';
        $scope.updateFilter();
    };

    function getSearchParams() {
        return {
            search: $scope.search,
            status: $scope.status,
            dateFrom: $scope.dateRange.dateFrom,
            dateTo: PUtill.addDay($scope.dateRange.dateTo)
        };
    }
    function init() {
        if ($routeParams.filter) {
            $scope.search = $routeParams.filter;
        }
        if (!$scope.search) {
            $scope.search = "";
        }
        $scope.updateFilter();
    }

    init();

    // ReSharper disable JsUnreachableCode
    gettext('Email, Name, Contract Id, Customer Id, Document Name');

};
EmailsController.$inject = ['$scope', 'Email', 'PUtill', 'gettext', '$routeParams', 'DatepickerUtils'];
